'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useNewReleasesAllSectionsData } from '@/app/[locale]/(worlds)/(worlds-landing)/new/components/useNewReleasesAllSectionsData';
import { SectionPageBlock, SectionPageSkeleton } from '@/app/[locale]/(worlds)/components/ExploreViverseAllSections';
import { LoadingDots } from '@/components/LoadingDots';
import ViverseSkeleton from '@/components/ViverseSkeleton';
import { useConfigsContext } from '@/context/ConfigsContext';
import { useWorldSearchContext } from '@/context/WorldSearchContext';
import { useLoadMore } from '@/hooks/useLoadMore';
export default function NewReleases() {
  const $ = _c(35);
  const t = useTranslations();
  const {
    store
  } = useConfigsContext();
  const {
    mobileNavHeight
  } = useWorldSearchContext();
  const htcToken = store?.credentials?.htcToken;
  let t0;
  if ($[0] !== htcToken) {
    t0 = {
      htcToken
    };
    $[0] = htcToken;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    pages,
    gamesPageLimit,
    enableLoadMore,
    isLoading,
    pagination
  } = useNewReleasesAllSectionsData(t0);
  let t1;
  if ($[2] !== enableLoadMore || $[3] !== pagination) {
    t1 = {
      enabled: enableLoadMore,
      ...pagination
    };
    $[2] = enableLoadMore;
    $[3] = pagination;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const loadMoreRef = useLoadMore(t1);
  const hasContent = pages.some(_temp);
  if (!hasContent && !isLoading) {
    return null;
  }
  let t2;
  if ($[5] !== mobileNavHeight) {
    t2 = {
      marginBottom: mobileNavHeight
    };
    $[5] = mobileNavHeight;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t) {
    t3 = t("worlds-landing.new.new-releases.title");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <div className="subheader-3 lg:subheader-2 px-4 font-semibold md:px-8 lg:px-6 lg:font-semibold">{t3}</div>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== htcToken || $[12] !== pages) {
    let t6;
    if ($[14] !== htcToken) {
      t6 = (page_0, index) => <SectionPageBlock key={index} page={page_0} dataRoomIdPrefix="nr" hideLiked={!htcToken} />;
      $[14] = htcToken;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    t5 = pages.map(t6);
    $[11] = htcToken;
    $[12] = pages;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[16] !== gamesPageLimit || $[17] !== isLoading || $[18] !== pages.length) {
    t6 = isLoading && pages.length === 0 && <SectionPageSkeleton gamesCount={gamesPageLimit} />;
    $[16] = gamesPageLimit;
    $[17] = isLoading;
    $[18] = pages.length;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== enableLoadMore || $[21] !== loadMoreRef) {
    t7 = enableLoadMore && <div ref={loadMoreRef} className="h-1" />;
    $[20] = enableLoadMore;
    $[21] = loadMoreRef;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t5 || $[24] !== t6 || $[25] !== t7) {
    t8 = <div className="mt-4 flex flex-col gap-10">{t5}{t6}{t7}</div>;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== pages.length || $[28] !== pagination.isValidating) {
    t9 = pagination.isValidating && pages.length > 0 && <LoadingDots />;
    $[27] = pages.length;
    $[28] = pagination.isValidating;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== t2 || $[31] !== t4 || $[32] !== t8 || $[33] !== t9) {
    t10 = <div className="flex flex-col" style={t2}>{t4}{t8}{t9}</div>;
    $[30] = t2;
    $[31] = t4;
    $[32] = t8;
    $[33] = t9;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  return t10;
}
function _temp(page) {
  return page.games.length > 0 || page.videos.length > 0 || page.experiences.length > 0;
}
export function NewReleasesSkeleton() {
  const $ = _c(6);
  const {
    mobileNavHeight
  } = useWorldSearchContext();
  let t0;
  if ($[0] !== mobileNavHeight) {
    t0 = {
      marginBottom: mobileNavHeight
    };
    $[0] = mobileNavHeight;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ViverseSkeleton className="h-6 w-32 px-4 md:h-6 md:px-8 lg:px-6" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mt-4 flex flex-col gap-10"><SectionPageSkeleton gamesCount={8} /></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t0) {
    t3 = <div className="flex flex-col" style={t0}>{t1}{t2}</div>;
    $[4] = t0;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}